/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Stat_This_MonthInputs */

const en_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this month`)
};

const es_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este mes`)
};

const fr_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ce mois-ci`)
};

const de_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Monat`)
};

const ja_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今月`)
};

const zh_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本月`)
};

const ar_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الشهر`)
};

const id_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bulan ini`)
};

const it_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`questo mese`)
};

const ru_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`в этом месяце`)
};

const pt_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`este mês`)
};

const ko_seller_dashboard_stat_this_month = /** @type {(inputs: Seller_Dashboard_Stat_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이번 달`)
};

/**
* | output |
* | --- |
* | "this month" |
*
* @param {Seller_Dashboard_Stat_This_MonthInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_stat_this_month = /** @type {((inputs?: Seller_Dashboard_Stat_This_MonthInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Stat_This_MonthInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_stat_this_month(inputs)
	if (locale === "es") return es_seller_dashboard_stat_this_month(inputs)
	if (locale === "fr") return fr_seller_dashboard_stat_this_month(inputs)
	if (locale === "de") return de_seller_dashboard_stat_this_month(inputs)
	if (locale === "ja") return ja_seller_dashboard_stat_this_month(inputs)
	if (locale === "zh") return zh_seller_dashboard_stat_this_month(inputs)
	if (locale === "ar") return ar_seller_dashboard_stat_this_month(inputs)
	if (locale === "id") return id_seller_dashboard_stat_this_month(inputs)
	if (locale === "it") return it_seller_dashboard_stat_this_month(inputs)
	if (locale === "ru") return ru_seller_dashboard_stat_this_month(inputs)
	if (locale === "pt") return pt_seller_dashboard_stat_this_month(inputs)
	return ko_seller_dashboard_stat_this_month(inputs)
});